// A variant without an entry has no Anleitung tab.
export const KNOWLEDGE_COMMIT = "79fae73f256e8abd4b8578690b0ef5bbcaf3eb3f";

export const HANDBUECHER: Readonly<Record<string, string>> = {
  vergabe: "visuals/coach-handbuch.html",
};

/** Where the build serves a variant's handbook PDF, or null when it has none. */
export const anleitungUrl = (variant: string): string | null =>
  Object.hasOwn(HANDBUECHER, variant) ? `/anleitung/${variant}.pdf` : null;
